import MarketFeed from "./MarketFeed";

export default MarketFeed;
